<div class="job-page-header">
  <span
    class="material-symbols-outlined job-page-header__status"
    [class.job-page-header__status--loading]="showSpinner()"
    [class.is-error]="!showSpinner() && presentation().color === 'error'"
    [class.is-done]="!showSpinner() && presentation().color === 'success'"
    [attr.aria-label]="showSpinner() ? 'Job activity in progress' : null">
    {{ showSpinner() ? 'progress_activity' : presentation().icon }}
  </span>
  <h1>{{ title() }}</h1>
  @if (numericJobId() && state().run) {
    <span>{{ presentation().status }}</span>
  }
  <button
    cuiButton
    square
    variant="plain"
    [cuiDropdownTriggerFor]="jobMenu"
    [disabled]="actionsDisabled()"
    type="button"
    aria-label="Job actions">
    <span class="material-symbols-outlined" aria-hidden="true">more_vert</span>
  </button>

  <cui-dropdown #jobMenu>
    <button
      cuiButton
      cdkMenuItem
      class="cui-dropdown__item"
      variant="plain"
      type="button"
      (click)="requestDelete()">
      <span class="material-symbols-outlined" aria-hidden="true">delete</span>
      Delete Job
    </button>
  </cui-dropdown>
</div>
